import { store } from '../store/store';
import Focus from '../types/enums/focus';

const FocusUtils = {
  evaluateFocus(focus: Focus | number) {
    const { focus: focusSlice } = store.getState();
    return (focusSlice.focus as []).length
      ? (focusSlice.focus as Focus[]).includes(focus)
      : focusSlice.focus === focus;
  },
  evaluateSpecificFocus(focus: Focus, focusToEvaluate: Focus | Focus[]) {
    return (focusToEvaluate as []).length
      ? (focusToEvaluate as Focus[]).find((item) => {
          return item === focus;
        })
      : focusToEvaluate === focus;
  },
};

export default FocusUtils;
